import React, { useContext,useMemo } from "react";

import { Box,List } from "@catchoftheday/cg-components";

import { NavigationItem } from "../../../../../../types";
import { SHOP_BY_BRAND_ID } from "../../../consts";
import { MenuItem } from "../../../MenuItem";
import { MobileMenuContext } from "../../../MobileMenuContext";
import {
  ActiveIdPath,
  TransformedShop,
  TransformedShopNavigationGroups,
} from "../../../types";
import { getCategoriesMenu } from "../CategoriesMenu";
import { getSubCategoriesMenu } from "../SubCategoriesMenu";

export type LinksMenuProps = {
  idPath: ActiveIdPath;
};

export const LinksMenu = ({ idPath, ...props }: LinksMenuProps) => {
  const { shops = [] } = useContext(MobileMenuContext);
  const activeCategory = useMemo<TransformedShop | undefined>(
    () => getCategoriesMenu(shops).find(({ id }) => id === idPath[0]),
    [shops, idPath]
  );

  const activeSubCategory = useMemo<
    TransformedShopNavigationGroups | undefined
  >(
    () =>
      (getSubCategoriesMenu(activeCategory) || []).find(
        ({ id }) => id === idPath[1]
      ),
    [idPath, activeCategory]
  );

  const linksMenu = useMemo<NavigationItem[] | undefined>(() => {
    if (
      !activeSubCategory ||
      activeSubCategory.shopNavigationItems.length === 0
    ) {
      return undefined;
    }

    return activeSubCategory.shopNavigationItems;
  }, [activeSubCategory]);

  if (!linksMenu || !activeCategory || !activeSubCategory) {
    return null;
  }

  const isShopByBrand = activeSubCategory.id === SHOP_BY_BRAND_ID;

  return (
    <Box as="nav" overflowY="scroll" {...props}>
      <List my="0px">
        {!isShopByBrand && (
          <MenuItem
            key={`Shop All ${activeSubCategory.name}-0`}
            url={activeSubCategory.url}
            hasChildren={false}
            itemPath={[
              {
                name: activeCategory.name,
                id: activeCategory.id,
                position: activeCategory.position,
              },
              {
                name: activeSubCategory.name,
                id: activeSubCategory.id as number,
                position: activeSubCategory.position,
              },
              {
                name: `Shop All ${activeSubCategory.name}`,
                id: activeSubCategory.id as number,
                position: 1,
              },
            ]}
            shopAll
          >
            {`Shop All ${activeSubCategory.name}`}
          </MenuItem>
        )}
        {linksMenu.map((menuItem, index) => (
          <MenuItem
            key={`${menuItem.name}-${index + 1}`}
            url={menuItem.url}
            hasChildren={false}
            itemPath={[
              {
                name: activeCategory.name,
                id: activeCategory.id,
                position: activeCategory.position,
              },
              {
                name: activeSubCategory.name,
                id: isShopByBrand
                  ? activeCategory.id
                  : (activeSubCategory.id as number),
                position: activeSubCategory.position,
              },
              {
                name: menuItem.name,
                id: menuItem.id,
                // Start from 1 and account for the Shop All link
                // If level 2 is Shop by Brand, Shop All doesn't need to be accounted for
                position: index + (isShopByBrand ? 1 : 2),
              },
            ]}
          >
            {menuItem.name}
          </MenuItem>
        ))}
      </List>
    </Box>
  );
};
